import { useState } from "react"

const isValidDraftValue = (draftValue: string) => draftValue !== '' && !isNaN(Number(draftValue))

export const EditableTableCell = ({
  prefix,
  suffix,
  value,
  onChange,
  style,
}: {
  prefix?: string;
  suffix?: string;
  value: string;
  onChange: (_: string) => void;
  style?: React.CSSProperties
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [draftValue, setDraftValue] = useState(value);
  return isEditing ? (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        fontWeight: 'bold',
        verticalAlign: 'middle',
        justifyContent: 'center',
        ...style,
      }}
    >
      <p>{prefix}</p>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <input
          style={{
            maxWidth: '80px',
            fontSize: 16,
            fontWeight: 'bold',
            textAlign: 'left',
            margin: '0 5px',
            padding: '0px 5px',
            borderRadius: 15,
            height: 35,
            backgroundColor: 'white',
            border: '2px solid',
          }}
          autoFocus
          value={draftValue}
          onChange={(e) => setDraftValue(e.target.value)}
          onBlur={() => setTimeout(() => isEditing && setIsEditing(false), 100)}
        />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <button
          style={{
            backgroundColor: '#49D594',
            color: 'white',
            height: 30,
            width: 30,
            marginLeft: '5px',
          }}
          onClick={() => {
            if (isValidDraftValue(draftValue)) {
              onChange(draftValue);
              setIsEditing(false);
            }
          }}
        >
          ✔
        </button>{' '}
      </div>
      {!isValidDraftValue && <span style={{ color: 'red' }}>Invalid</span>}
    </div>
  ) : (
    <div style={{ ...style }}>
      <button onClick={() => setIsEditing(true)}>
        <span style={{
          borderBottom: "2px solid"
        }}>
          {prefix}
          {value}
          {suffix}
        </span>
      </button>
    </div>
  );
};